<template>
  <common-page-table
    :apiName="apiName"
    :nameRole="nameRoleEntity"
    :titleTable="$t('Агентства')"
    :paramsGetData="paramsGetData"
    :fieldLand="fieldLang"
    :keyTable="'id'"
    :deleteParams="deleteParams"
    :apiDeleteName="apiDeleteName"

    :forceIsCreate="false"
    :forceIsEdit="false"
    :forceDelete="false"
  />
</template>
<script>
import { NAME_OBJECT } from "../../../../RoleConstanans";
import CommonPageTable from "../../commonElement/CommonPageTable.vue";
import { API_METHODS, FIELD_LANG_COMPANY} from "../../../../constant";
import formatData from "../../../../helpers/converters/formatData";
import convertLangDataToTable from "../../../../helpers/converters/convertLangDataToTable";
export default {
  name: "AgentTablePage",
  components: { CommonPageTable },
  data() {
    return {
      fieldLang: FIELD_LANG_COMPANY,
      apiName: API_METHODS.GET_ALL_COMPANY,
      apiDeleteName: API_METHODS.DELETE_COMPANY
    };
  },
  computed: {
    paramsGetData() {
      return { typeCompany: 'Agency' };
    },
    nameRoleEntity() {
      return NAME_OBJECT.agent
    }
  },
  methods: {
    deleteParams(id) {
      return { id: id };
    },
  }
};
</script>
